module.exports = __webpack_public_path__ + "static/bankbeat-logo-banner-9a648574bfbb1cc1985e49f0641cfbc5.png";